// @mui
import { Box, Link, Paper, Stack, Typography } from '@mui/material';
import NextLink from "next/link";
import { Logo } from 'src/components';

// ----------------------------------------------------------------------

export default function JobCompanyInfo() {
  return (
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, bgcolor: 'background.default' }}>
      <Stack spacing={2} direction="row" alignItems="center">
        <Box sx={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Logo sx={{ width: 48 }} />
        </Box>

        <Stack spacing={0.5}>
          <Typography variant="h6">Bergen Elektro Automasjon</Typography>
          <NextLink href="/om-oss" passHref>
            <Link variant="body3" sx={{ color: 'text.secondary' }}>
              Les om selskapet
            </Link>
          </NextLink>
        </Stack>
      </Stack>
    </Paper>
  );
}
